export const config = {
  title: "Patty Cleaning Service | Professional Cleaning Services in Denver, CO",
  meta: {
    description:
      "Patty Cleaning Service offers high-quality residential, office, deep, post-construction, move-in/move-out, and window cleaning services in Denver, CO. We prioritize customer satisfaction and excellence.",
    keywords: [
      'Cleaning Services Denver CO',
      'Residential Cleaning Denver',
      'Office Cleaning Denver',
      'Deep Cleaning Denver',
      'Post-Construction Cleaning',
      'Move-In Cleaning',
      'Move-Out Cleaning',
      'Patty Cleaning Service',
      'Colorado Cleaning Services',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Patty Cleaning Service",
    canonicalUrl: 'https://www.pattycleaningservice.com/',
  },
  sections: {
    header: {
      businessName: "Patty Cleaning Service",
    },
    sectionB: {
      heroTitle: "Patty Cleaning Service",
      heroSubtitle: 'Transforming Spaces, Making Them Sparkle!',
      learnAboutText: 'Explore Services',
      phoneNumber: '7204345742',
      phoneLabel: '(720) 434-5742',
      heroBackgroundImage:
        'https://static.wixstatic.com/media/11062b_327964cfd02b4cb38e4010e98f30fd42~mv2.jpeg',
      cardData: [
        {
          title: 'Residential Cleaning',
          description:
            'Meticulous cleaning services for homes, ensuring a spotless and welcoming environment.',
        },
        {
          title: 'Office Cleaning',
          description:
            'Keep your workspace clean and productive with our reliable office cleaning services.',
        },
        {
          title: 'Post-Construction Cleaning',
          description:
            'Thorough cleaning after construction projects, leaving your space ready to use.',
        },
      ],
      description:
        "Patty Cleaning Service provides expert cleaning solutions to keep your home or business space fresh and clean. We cater to various cleaning needs with precision and reliability.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore our diverse range of cleaning services, tailored to suit residential and commercial needs alike.",
      cards: [
        {
          title: 'Window Cleaning',
          description:
            'Crystal-clear window cleaning for homes and offices, enhancing visibility and aesthetics.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/8cd670aa-04aa-422d-a4c1-bd2ae4bd09edece8.png?alt=media&token=cd990c0b-b82f-4d9b-91fc-d79207a6b60a',
          imageAlt: 'Window Cleaning Services',
        },
        {
          title: 'Move-In/Move-Out Cleaning',
          description:
            'Thorough cleaning services for tenants or landlords to prepare spaces for the next resident.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/72cfc589-9093-4e2d-baf7-dc6d179eca0149cc.jpg?alt=media&token=fd49b408-7631-4d2d-b03f-42b15e667fcc',
          imageAlt: 'Move-In/Move-Out Cleaning Services',
        },
        {
          title: 'Standard Cleaning',
          description:
            'Comprehensive cleaning solutions for spaces that need extra care and attention.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/6d44450a-5d6c-47d2-9a6b-81278bf34560c00a.png?alt=media&token=77917050-6e42-4b96-b435-bc2ecf5eb343',
          imageAlt: 'Standard Cleaning Services',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Event Cleaning',
        'Office Cleaning',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/27d6d05c-b4d0-4b0e-a4b0-b4e4d825eb35d8cd.jpg?alt=media&token=4bac70e1-d763-455f-b4be-89b5670341d3',
        alt: "Patty Cleaning Service",
      },
      aboutText: [
        "Welcome to Patty Cleaning Service, your trusted cleaning provider in Denver, Colorado. We are a family-owned business dedicated to top-tier service.",
        "Our professional team specializes in Standard Cleaning, Office Cleaning, Move-In/Move-Out Cleaning, Window Cleaning, and Event Cleaning services. With an unwavering commitment to excellence, we ensure every space shines.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Patty Cleaning Service Logo",
      businessName: "Patty Cleaning Service",
      contact: {
        phone: '7204345742',
        phoneLabel: '(720) 434-5742',
        email: 'info@pattycleaningservice.com',
        website: 'https://www.pattycleaningservice.com/',
        address: 'Denver, Colorado, US',
      },
      socialMedia: {
        googlePlus: 'https://business.google.com/n/4684032295015721299/searchprofile',
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Denver, Colorado, US',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.5760110136727!2d-96.601423!3d32.766799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e8275ef56e1e7%3A0x0!2zMzLCsDQ2JzAwLjgiTiA5NsKwMzYnMDMuMiJX!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus',
    },
  },
};

export default config;
